import { create } from 'zustand'
import { onSessionEnd } from '../../lib/session.js'

/** Transient chat state: who is typing where. */
interface ChatState {
  typing: Record<string, number>
  setTyping: (conversationId: string) => void
}
export const useChat = create<ChatState>((set, get) => ({
  typing: {},
  setTyping(conversationId) {
    // Keep only the threads still inside the typing window, so the map never grows (bugs.md).
    const now = Date.now()
    const typing: Record<string, number> = { [conversationId]: now }
    for (const [id, at] of Object.entries(get().typing)) if (now - at < TYPING_MS) typing[id] ??= at
    set({ typing })
  },
}))
const TYPING_MS = 4000
export const isTyping = (typing: Record<string, number>, id: string) =>
  Date.now() - (typing[id] ?? 0) < TYPING_MS

onSessionEnd(() => useChat.setState({ typing: {} }))
